import { clamp, prefersReducedMotion } from '@kame/lib';

const LINE = 0.62;

class KameCraftPanel extends HTMLElement {
  connectedCallback() {
    if (this.listeners) return;
    this.listeners = new AbortController();
    this.timeline = this.querySelector('[data-timeline]');
    this.steps = [...this.querySelectorAll('[data-step]')];
    this.countEl = this.querySelector('[data-count]');
    this.total = this.steps.length;
    this.lit = -1;

    if (!prefersReducedMotion()) {
      this.classList.add('is-armed');
      this.revealObserver = new IntersectionObserver(
        ([entry]) => this.classList.toggle('is-inview', entry.isIntersecting),
        { rootMargin: '-12% 0px -12% 0px' }
      );
      this.revealObserver.observe(this);
    }

    if (!this.timeline || !this.total) return;
    this.classList.add('is-charge');
    this.frame = 0;
    const schedule = () => {
      if (!this.visible || this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.update();
      });
    };
    const { signal } = this.listeners;
    document.addEventListener('scroll', schedule, { capture: true, passive: true, signal });
    window.addEventListener('resize', schedule, { signal });
    this.visibleObserver = new IntersectionObserver(([entry]) => {
      this.visible = entry.isIntersecting;
      schedule();
    });
    this.visibleObserver.observe(this);
    this.update();
  }

  disconnectedCallback() {
    this.listeners?.abort();
    this.listeners = null;
    this.revealObserver?.disconnect();
    this.visibleObserver?.disconnect();
    cancelAnimationFrame(this.frame);
    this.frame = 0;
    this.classList.remove('is-armed', 'is-inview', 'is-charge', 'is-full');
  }

  update() {
    const line = window.innerHeight * LINE;
    const rect = this.timeline.getBoundingClientRect();
    const progress = clamp((line - rect.top) / Math.max(rect.height, 1), 0, 1);
    this.timeline.style.setProperty('--progress', progress.toFixed(3));
    this.style.setProperty('--charge', Math.pow(progress, 1.25).toFixed(3));

    let lit = 0;
    this.steps.forEach((step) => {
      const on = step.getBoundingClientRect().top < line;
      step.classList.toggle('is-lit', on);
      if (on) lit += 1;
    });
    if (lit === this.lit) return;
    this.lit = lit;
    if (this.countEl) this.countEl.textContent = String(lit).padStart(2, '0');
    this.classList.toggle('is-full', lit === this.total);
  }
}

if (!customElements.get('kame-craft-panel')) customElements.define('kame-craft-panel', KameCraftPanel);
